<sc-flex [vertical]="true" [stretchContent]="true" [fitHeight]="true">
  <sc-dialog-title>{{'edit option' | translate:
    ['tmc-yard.ui.admin.transport-options-administration.transport-option-editor.title',
    translationService.language]}}</sc-dialog-title>
  <sc-flex-fitting-content [vertical]="true">
    <sc-padding [fitHeight]="true">
      <sc-master-detail [selection]="[selectedMenuEntry]" [data]="menuEntries" [readOnly]="true"
        (selectionChanged)="onSelectionChanged($event)" [newStyle]="true">
        <app-transport-option-editor-labeling [transportOption]="transportOption" *ngIf="currentViewKey === 'labeling'"
          (changed)="onDetailsChanged()"></app-transport-option-editor-labeling>
        <app-transport-option-editor-control [transportOption]="transportOption" *ngIf="currentViewKey === 'control'"
          (changed)="onDetailsChanged()"></app-transport-option-editor-control>
        <app-transport-option-editor-validation [transportOption]="transportOption"
          *ngIf="currentViewKey === 'validation'"
          (changed)="onDetailsChanged()"></app-transport-option-editor-validation>
        <app-transport-option-editor-loading [transportOption]="transportOption" *ngIf="currentViewKey === 'loading'"
          (changed)="onDetailsChanged()"></app-transport-option-editor-loading>
          <app-transport-option-editor-limits [transportOption]="transportOption" *ngIf="currentViewKey === 'limits'"
          (changed)="onDetailsChanged()"></app-transport-option-editor-limits>
        <app-transport-option-editor-parameter [transportOption]="transportOption"
          *ngIf="currentViewKey === 'parameter'" (changed)="onDetailsChanged()"></app-transport-option-editor-parameter>
        <app-transport-option-editor-files [transportOption]="transportOption" *ngIf="currentViewKey === 'files'"
          (changed)="onDetailsChanged()"></app-transport-option-editor-files>
      </sc-master-detail>
    </sc-padding>
  </sc-flex-fitting-content>
  <sc-actionbar>
    <sc-content-spacer [grow]="true"></sc-content-spacer>
    <button mat-stroked-button class="cancel-button" mat-button (click)="cancelDialog()">
      {{'cancel' |
      translate:['tmc-yard.ui.admin.transport-options-administration.transport-option-editor.action.cancel',
      translationService.language]}}
    </button>
    <sc-content-spacer></sc-content-spacer>
    <button mat-flat-button class="confirm-button" mat-button (click)="confirmDialog()" [disabled]="!optionValid">
      {{'confirm' |
      translate:['tmc-yard.action.confirm',
      translationService.language]}}
    </button>
  </sc-actionbar>
</sc-flex>
